import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { Text, Button, Heading, Container } from '@chakra-ui/react'

import { Page, Loading, ListGroup, ListGroupItem } from 'components'

import { useFormListQuery } from '../hooks'

export const FormChoosePage = () => {
  const navigate = useNavigate()
  const { data, loading } = useFormListQuery()

  useEffect(() => {
    if (data?.formList.results.length === 1) {
      navigate(`${data.formList.results[0].id}/submeter`)
    }
  }, [data, navigate])

  if (loading || data?.formList.results.length === 1) {
    return <Loading />
  }

  return (
    <Page justify='center'>
      <Container>
        <Heading size='xl' align='center' mb={5}>
          Escolha um questionário
        </Heading>
        {!data?.formList.results.length && (
          <Text align='center'>Não existem questionário disponiveis para responder</Text>
        )}
        {!!data?.formList.results.length && (
          <ListGroup>
            {data?.formList.results.map((form, index) => (
              <ListGroupItem
                key={index}
                actions={
                  <Button
                    height='100%'
                    borderRadius='0'
                    variant='ghost'
                    aria-label='Adicionar'
                    rightIcon={<ChevronRightIcon />}
                    onClick={() => navigate(`${form.id}`)}>
                    Responder
                  </Button>
                }>
                <Text fontSize='xl'>{form.name}</Text>
              </ListGroupItem>
            ))}
          </ListGroup>
        )}
      </Container>
    </Page>
  )
}

export default FormChoosePage
